import { createBrowserRouter, Navigate } from 'react-router-dom'
import { Layout } from './components/layout'
import { NEW_PRICING_ENABLED } from './utils/featureFlags'
import {
  HomePage,
  PricingPage,
  PricingPageV2,
  DemoPage,
  SignUpPage,
  AboutPage,
  NotFoundPage,
  JourneyPage,
  ValueOfAdvicePage,
  SecurityPage,
  PrivacyPolicyPage,
  TermsPage,
  ResourcesPage,
  BlogIndexPage,
  BlogPostPage,
  ProjectionMethodologyPage,
  HelpUsBuildPage,
  CaseStudiesPage,
  AIBuyersChecklistPage,
  PricingUpdatePage,
  SignUpPageV2,
  ProductHubPage,
  ProductModulePage,
  ModuleExplorePage,
} from './pages'

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      // Core pages
      { path: '/', element: <HomePage /> },
      { path: '/features', element: <Navigate to="/product" replace /> },

      // Product: module showcase hub + per-module pages
      { path: '/product', element: <ProductHubPage /> },
      { path: '/product/explore', element: <ModuleExplorePage /> },
      { path: '/product/:slug', element: <ProductModulePage /> },
      { path: '/pricing', element: NEW_PRICING_ENABLED ? <PricingPageV2 /> : <PricingPage /> },
      ...(NEW_PRICING_ENABLED
        ? [{ path: '/pricing-update', element: <PricingUpdatePage /> }]
        : []),
      { path: '/demo', element: <DemoPage /> },
      { path: '/about', element: <AboutPage /> },
      { path: '/sign-up', element: NEW_PRICING_ENABLED ? <SignUpPageV2 /> : <SignUpPage /> },
      { path: '/security', element: <SecurityPage /> },
      { path: '/ai-buyers-checklist', element: <AIBuyersChecklistPage /> },

      // Case studies (reworked from journeys)
      { path: '/case-studies', element: <CaseStudiesPage /> },
      { path: '/case-studies/:slug', element: <JourneyPage /> },

      // Resources & Blog
      { path: '/resources', element: <ResourcesPage /> },
      { path: '/blog', element: <BlogIndexPage /> },
      { path: '/blog/:slug', element: <BlogPostPage /> },
      { path: '/help-us-build', element: <HelpUsBuildPage /> },
      { path: '/value-of-advice', element: <ValueOfAdvicePage /> },
      { path: '/projection-methodology', element: <ProjectionMethodologyPage /> },

      // Partners
      { path: '/partner-programme', element: <Navigate to="/" replace /> },
      { path: '/partner-signup', element: <Navigate to="/" replace /> },
      { path: '/partner-dashboard', element: <Navigate to="/" replace /> },

      // Legal
      { path: '/privacy-policy', element: <PrivacyPolicyPage /> },
      { path: '/terms', element: <TermsPage /> },

      // Redirects: deleted pages
      { path: '/modules', element: <Navigate to="/product" replace /> },
      { path: '/advisers', element: <Navigate to="/" replace /> },
      { path: '/overview', element: <Navigate to="/" replace /> },
      { path: '/get-started', element: <Navigate to="/sign-up" replace /> },
      { path: '/book-demo', element: <Navigate to="/sign-up" replace /> },
      { path: '/book-instant-start', element: <Navigate to="/sign-up" replace /> },
      { path: '/contact', element: <Navigate to="/sign-up" replace /> },
      { path: '/investment-managers', element: <Navigate to="/" replace /> },
      { path: '/investment-managers/contact', element: <Navigate to="/sign-up" replace /> },
      { path: '/mortgage-advisers', element: <Navigate to="/" replace /> },
      { path: '/mortgage-advisers/contact', element: <Navigate to="/sign-up" replace /> },
      { path: '/journeys', element: <Navigate to="/case-studies" replace /> },
      { path: '/journey/meeting-to-done', element: <Navigate to="/case-studies/meeting-to-done" replace /> },
      { path: '/journey/ramble-to-action', element: <Navigate to="/case-studies/ramble-to-action" replace /> },
      { path: '/journey/practice-growth', element: <Navigate to="/case-studies/practice-growth" replace /> },
      { path: '/journey/:slug', element: <Navigate to="/case-studies" replace /> },

      // 404
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])
